/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Type_LabelInputs */

const en_consumer_declaration_type_label = /** @type {(inputs: Consumer_Declaration_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declaration type`)
};

const de_consumer_declaration_type_label = /** @type {(inputs: Consumer_Declaration_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art der Erklärung`)
};

const fr_consumer_declaration_type_label = /** @type {(inputs: Consumer_Declaration_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de déclaration`)
};

const es_consumer_declaration_type_label = /** @type {(inputs: Consumer_Declaration_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de declaración`)
};

const it_consumer_declaration_type_label = /** @type {(inputs: Consumer_Declaration_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di dichiarazione`)
};

const nl_consumer_declaration_type_label = /** @type {(inputs: Consumer_Declaration_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soort verklaring`)
};

const pl_consumer_declaration_type_label = /** @type {(inputs: Consumer_Declaration_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rodzaj oświadczenia`)
};

const fi_consumer_declaration_type_label = /** @type {(inputs: Consumer_Declaration_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoituksen tyyppi`)
};

const da_consumer_declaration_type_label = /** @type {(inputs: Consumer_Declaration_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erklæringstype`)
};

const sv_consumer_declaration_type_label = /** @type {(inputs: Consumer_Declaration_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ av förklaring`)
};

/**
* | output |
* | --- |
* | "Declaration type" |
*
* @param {Consumer_Declaration_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_type_label = /** @type {((inputs?: Consumer_Declaration_Type_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Type_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_type_label(inputs)
	if (locale === "fr") return fr_consumer_declaration_type_label(inputs)
	if (locale === "es") return es_consumer_declaration_type_label(inputs)
	if (locale === "it") return it_consumer_declaration_type_label(inputs)
	if (locale === "nl") return nl_consumer_declaration_type_label(inputs)
	if (locale === "pl") return pl_consumer_declaration_type_label(inputs)
	if (locale === "fi") return fi_consumer_declaration_type_label(inputs)
	if (locale === "da") return da_consumer_declaration_type_label(inputs)
	if (locale === "sv") return sv_consumer_declaration_type_label(inputs)
	return en_consumer_declaration_type_label(inputs)
});